export default __webpack_public_path__ + "static/media/buy2.94ee0494.png";